<template>
  <div class="confirmOpen">
    <c-nav></c-nav>
    <div class="card">
      <div class="title fx-row a-text-18">
        <div class="icon"></div>
        <div class="desc">高铁管家钻石会员</div>
        <div class="price">¥199元/年</div>
      </div>
      <div class="detail a-text-13">
        <div>火车票首单立返50元，每单再返10元</div>
        <div>另送最佳助攻手、机票买贵赔、酒店会员价等福利</div>
      </div>
    </div>
    <!-- <div class="verify">
      <div class="tel">
        <div class="title a-text-15">手机号码</div>
        <div class="inputWrap">
          <input type="tel" placeholder="请输入你的手机号码" class="a-text-15">
          <div class="getCode a-text-15 a-blue">获取验证码</div>
        </div>
      </div>
      <div class="verifyCode">
        <div class="title a-text-15">验证码</div>
        <div class="inputWrap">
          <input type="tel" placeholder="请输入6位验证码" class="a-text-15">
        </div>
      </div>
      <div class="tips t-a-r a-text-13">*开通后在高铁管家登录此手机号即可</div>
    </div>-->
    <div class="agreeText fx-row">
      <div :class="['a-radio',isAgree?'a-checked':'']" @click="agree"></div>
      <div class="text a-text-13 a-gray">
        已阅读并同意
        <span class="a-blue" @click="gotoVIPInstruction">《高铁管家会员用户协议》</span>
      </div>
    </div>
    <div class="submit a-btn-line-border" @click="gotoPay">
      <div class="a-btn">支付199元 开通钻石会员</div>
    </div>
  </div>
</template>
<script>
import auth from "@/request/auth.js";
import localStorage from "@/utils/localStorage.js";
import { mapState, mapMutations, mapActions } from "vuex";
import { get } from "@/request/utils";
import { h5PayV3 } from '@/utils/payHandler'

export default {
  data() {
    return {
      authphone: "",
      isReplaceWxPayPage: false // 跳转去h5支付页面是否需要replace当前页面
    };
  },
  computed: {
    ...mapState("vipCard/huaweiVIP", ["isAgree"])
  },
  created() {
    let isReplaceWxPayPage = localStorage.get("isReplaceWxPayPage");
    if (isReplaceWxPayPage) {
      this.isReplaceWxPayPage = true;
      localStorage.remove("isReplaceWxPayPage");
    }
  },
  mounted() {
    this.$updateTitle("开通钻石会员");

    let { authphone } = this.$route.query;
    if (authphone) {
      this.authphone = authphone;
    }
  },
  methods: {
    ...mapMutations("vipCard/huaweiVIP", ["CHANGE_AGREEMENT"]),
    ...mapActions("vipCard/huaweiVIP", ["creatHuaweiOrder"]),
    agree() {
      this.CHANGE_AGREEMENT();
    },
    gotoVIPInstruction() {
      this.$router.push({
        path: "/vipCard/VIPInstruction"
      });
    },
    gotoPay() {
      if (this.isAgree) {
        auth
          .ensure({
            method: "replace"
          })
          .then(() => {
            this.onPaying();
          })
          .catch(err => {
            this.$notify({
              type: "error",
              message: (err && err.msg) || "登录失败，请稍后再试",
              showClose: true
            });
          });
      } else {
        this.$notify({
          message: "请阅读并同意高铁管家会员用户协议",
          showClose: true
        });
      }
    },
    onPaying() {
      let origin = localStorage.get("ptid") || "";
      this.creatHuaweiOrder({
        id: "priv_003",
        buyType: 1,
        origin
      })
      .then(res => {
        const payOrderId = get(res, "res.bd.data.payid", "");
        const oid = get(res, "res.bd.data.orderid", "");
        const ptid = localStorage.get("ptid") || "";
        const currentUrl = location.href.split('?')[0];
        const successPage = `${currentUrl}?oid=${oid}&ptid=${ptid}`

        h5PayV3({
          payorderid: payOrderId,
          orderid:oid,
          expireMinute: 30,
          template: {
            name: 'act',
            data: {
              title: '高铁管家钻石会员',
              desc : '有效期365天',
              img  : 'https://cdn.133.cn/gtgj/web/huaweiVIP/icon_diamond@3x.png'
            }
          },
          ru:successPage
        })
      })
    },
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/_vars.scss";
@import "./style/common.scss";
.confirmOpen {
  color: #333;
  min-height: 100%;
  .card {
    @include bg("Mask@3x.png");
    width: 335 * $px;
    height: 119 * $px;
    margin: 0 auto;
    margin-top: 10 * $px;
    padding-top: 20 * $px;
    padding-left: 12 * $px;
    box-sizing: border-box;
    color: #93632d;
    .title {
      .icon {
        width: 28 * $px;
        height: 28 * $px;
        @include bg("icon_diamond@3x.png");
      }
      .desc {
        margin-left: 4 * $px;
      }
      .price {
        margin-left: 46 * $px;
      }
    }
    .detail {
      margin-top: 14 * $px;
      div {
        margin-bottom: 4 * $px;
      }
    }
  }
  .verify {
    margin: 20 * $px;
    .tel,
    .verifyCode {
      .title {
        margin-bottom: 10 * $px;
      }
      .inputWrap {
        position: relative;
        border-bottom: 1px solid #ebebeb;
        padding-bottom: 10 * $px;
        .getCode {
          position: absolute;
          line-height: 28 * $px;
          right: 0;
          top: 0;
        }
      }
    }
    .verifyCode {
      margin-top: 15 * $px;
    }
    .tips {
      color: #c3c3c3;
      margin-top: 10 * $px;
    }
  }
  .agreeText {
    // margin-top: 380*$px;
    position: fixed;
    bottom: 80 * $px;
    .a-radio {
      width: 24 * $px;
      height: 24 * $px;
      margin-left: 54 * $px;
      margin-right: 10 * $px;
    }
    .text {
      line-height: 24 * $px;
    }
  }
  .submit {
    bottom: 0;
    position: fixed;
    padding: 8 * $px;
    box-sizing: border-box;
    width: 100%;
    .text {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/vipCard/pages/huaweiVIP/confirmOpen.vue